import { Dialog } from 'primereact/dialog'
import { useTeamDetailsPopup } from '../../Hooks/Features/ProjectGlance/useTeamDetailsPopup'
import { SkeletonDataTable } from '../Loader/Loader';
import CommonGrid from '../CommonCompo/CommonGrid/CommonGrid';
import WorklogDetails from './WorklogDetails';
import { useTeamComposition } from '../../Hooks/Features/ProjectGlance/useTeamComposition';

const TeamDetailsPopup = ({ projectId, projectName, details, onClose }) => {

  const card = "team_composition";
  const { teamSummary } = useTeamComposition({ projectId, card });
  const { filterValues, setFilterValues, loader, columns, rowData, worklogDetails, setWorklogDetails } = useTeamDetailsPopup({ projectId, details });

  return (
    <div>
      <Dialog visible={details?.visible} onHide={() => onClose()} className='modal-xlarge' header={`Team Details of ${projectName}`} draggable={false} blockScroll>
        <div>
          <div className='d-flex gap-4'>
            <div className='d-flex align-items-center'>
              <input type='radio' name='member-status' id='current' checked={filterValues?.is_current} onChange={() => setFilterValues((prev) => ({ ...prev, is_current: true }))} />
              <label htmlFor='current'>Current Members</label>
            </div>
            <div className='d-flex align-items-center'>
              <input type='radio' name='member-status' id='past' checked={!filterValues?.is_current} onChange={() => setFilterValues((prev) => ({ ...prev, is_current: false }))} />
              <label htmlFor='past'>Past Members</label>
            </div>
          </div>
          <div className='d-flex gap-2 my-3 flex-wrap'>
            {teamSummary?.map(item => (
              <div key={item?.category_id} className={`d-flex gap-2 align-items-center border rounded-pill c-pointer px-3 py-1 ${filterValues?.category?.category_id === item?.category_id ? "bg-black text-white fw-semibold" : ""}`} style={{ paddingTop: "2px", paddingBottom: "2px" }} onClick={() => setFilterValues((prev) => ({ ...prev, category: item }))}>
                {item?.category_name} <div className={`d-flex align-items-center justify-content-center rounded-circle text-black`} style={{ width: "20px", height: "20px", backgroundColor: "#d8d8d8" }}>{item?.category_wise_counts}</div>
              </div>
            ))}
          </div>
          <div>
            <div className='w100' style={{ height: "50vh", overflowY: "auto" }}>
              {loader ? <SkeletonDataTable numSkeletons={15} />
                : <CommonGrid columns={columns} data={rowData} strippedTable={true} headerHeight={60} rowHeight={"auto"} />
              }
            </div>
          </div>

          {worklogDetails?.visible && <WorklogDetails projectId={projectId} showPopup={worklogDetails} onClose={() => setWorklogDetails((prev) => ({ ...prev, visible: false, group: {} }))} />}
        </div>
      </Dialog>
    </div>
  )
}

export default TeamDetailsPopup